import { getApiHost } from './getApiHost';

export async function getCustomerInfo(apiAccountClientId: string) {
  const response = await fetch(
    `/customer/current.jwt?app_client_id=${apiAccountClientId}`,
  );
  if (response.status !== 200) {
    throw new Error(`Failed to fetch JWT with status ${response.status}`);
  }

  const jwt = await response.text();
  const userInfoEndpoint = `${getApiHost()}/api/user-info`;

  const userInfoResponse = await fetch(userInfoEndpoint, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`,
    },
  });
  const info = await userInfoResponse.json();

  return info;
}
